<template>
    <div class="navigation-bar">
        <!-- 顶部欢迎栏 -->
        <div class="top-bar">
            <div class="top-content">
                <span class="welcome-text" :class="{ 'hide-time': isSmallMobile }">
                    欢迎来到数据资产全过程AI服务平台 {{ !isSmallMobile ? `(${currentTime})` : '' }}
                </span>
                <div class="auth-links" v-if="userInfo">
                    <el-link type="default" href="/index/home" class="auth-link" :underline="false">你好：{{ userInfo.name
                    }}</el-link>

                </div>
                <div class="auth-links" v-else>
                    <el-link type="default" href="/register" class="auth-link" :underline="false">注册</el-link>
                    <span class="separator">|</span>
                    <el-link type="primary" href="/login" class="auth-link" :underline="false">登录</el-link>
                </div>
            </div>
        </div>

        <!-- 主导航栏 -->
        <div class="nav-bar">
            <!-- 左侧：图标 + 平台名称 -->
            <div class="nav-left">
                <!-- <span class="nav_icon iconify" data-icon="ri:government-fill"
                    style="font-size: 20px; color: #1d4e6f;"></span> -->
                <img style="width: 40px;" src="../../public/logo.png" alt="logo">
                <h1 class="nav_title">数据资产全过程AI服务平台</h1>
            </div>

            <!-- 中间：导航菜单（桌面端） -->
            <el-menu :default-active="activeIndex" class="nav-menu desktop-menu" mode="horizontal"
                @select="handleSelect">
                <el-menu-item v-for="item in menuItems" :key="item.index" class="nav-menu-item" :index="item.index">
                    {{ item.label }}
                </el-menu-item>
            </el-menu>

            <!-- 右侧：搜索框 + 汉堡菜单 -->
            <div class="nav-right" v-if="isMobile">
                <!-- 桌面端搜索框 -->
                <!-- <div class="desktop-search">
                    <el-input placeholder="搜索内容" prefix-icon="el-icon-search" clearable></el-input>
                </div> -->

                <!-- 移动端汉堡菜单按钮 -->
                <div class="mobile-menu-toggle" @click="toggleMobileMenu">
                    <span class="hamburger-icon">
                        <i class="el-icon-menu"></i>
                    </span>
                </div>
            </div>
        </div>

        <!-- 移动端菜单（下拉式） -->
        <transition name="mobile-menu">
            <div class="mobile-menu-container" v-show="showMobileMenu">
                <div class="mobile-menu-overlay" @click="closeMobileMenu"></div>
                <div class="mobile-menu-content">
                    <div class="mobile-menu-items">
                        <div class="mobile-menu-item" v-for="item in menuItems" :key="item.index"
                            :class="{ 'active': activeIndex === item.index }"
                            @click="handleMobileMenuClick(item.index)">
                            {{ item.label }}
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'NavigationBar',
    props: {
        // 可以接收外部传入的激活菜单项
        defaultActiveIndex: {
            type: String,
            default: '1'
        }
    },
    data() {
        return {
            userInfo: {},
            currentTime: '',  // 当前时间
            activeIndex: this.defaultActiveIndex, // 默认选中的菜单项
            showMobileMenu: false, // 控制移动端菜单显示
            menuItems: [
                { index: '1', label: '首页', path: '/' },
                { index: '2', label: '数据登记', path: '/registration' },
                { index: '3', label: '合规审查', path: '/compliance' },
                { index: '4', label: '质量评价', path: '/quality' },
                { index: '5', label: '价值评估', path: '/valuation' },
                { index: '6', label: '金融对接', path: '/finance' },
                { index: '7', label: '联系我们', path: '/about' }
            ],
            isMobile: false, // 移动端状态判断
            isSmallMobile: false // 小屏幕移动端状态（宽度<420px）
        }
    },
    mounted() {
        this.getCurrentTime()
        // 定时更新时间
        this.timer = setInterval(this.getCurrentTime, 1000)

        // 初始化移动端状态
        this.checkMobile()
        this.checkSmallMobile()

        // 监听窗口大小变化
        window.addEventListener('resize', this.handleResize)

        // this.userInfo = 
        this.userInfo = JSON.parse(localStorage.getItem("user"));

        // console.log(JSON.parse(localStorage.getItem("user")));
        // 根据当前路由设置活跃菜单项
        this.setActiveMenuByRoute()

        // 监听路由变化
        this.$watch(() => this.$route, this.setActiveMenuByRoute)

    },
    beforeDestroy() {
        // 清除定时器
        if (this.timer) {
            clearInterval(this.timer)
        }

        // 移除事件监听
        window.removeEventListener('resize', this.handleResize)
    },
    methods: {
        // 获取当前时间
        getCurrentTime() {
            const now = new Date()
            const year = now.getFullYear()
            const month = String(now.getMonth() + 1).padStart(2, '0')
            const day = String(now.getDate()).padStart(2, '0')
            const hours = String(now.getHours()).padStart(2, '0')
            const minutes = String(now.getMinutes()).padStart(2, '0')
            const seconds = String(now.getSeconds()).padStart(2, '0')

            this.currentTime = `${year}年${month}月${day}日 ${hours}:${minutes}:${seconds}`
        },

        // 根据当前路由设置活跃菜单项
        setActiveMenuByRoute() {
            const currentPath = this.$route.path

            // 检查是否属于数据登记相关的路由
            if (currentPath.startsWith('/websiteFAQ') ||
                currentPath.startsWith('/assetDetail') ||
                currentPath.startsWith('/registration')) {
                this.activeIndex = '2'
                return
            }

            // 检查是否属于合规审查相关的路由
            if (currentPath.startsWith('/compliance')) {
                this.activeIndex = '3'
                return
            }

            // 检查是否属于质量评价相关的路由
            if (currentPath.startsWith('/quality')) {
                this.activeIndex = '4'
                return
            }

            // 检查是否属于价值评估相关的路由
            if (currentPath.startsWith('/valuation')) {
                this.activeIndex = '5'
                return
            }

            // 检查是否属于金融对接相关的路由
            if (currentPath.startsWith('/finance')) {
                this.activeIndex = '6'
                return
            }
            if (currentPath.startsWith('/about')) {
                this.activeIndex = '7'
                return
            }

            // 默认设置首页
            this.activeIndex = '1'
        },

        handleSelect(key, keyPath) {
            this.activeIndex = key

            // 根据选择的菜单项进行路由跳转
            const selectedItem = this.menuItems.find(item => item.index === key)
            if (selectedItem && selectedItem.path) {
                this.$router.push(selectedItem.path)
            }

            this.$emit('menu-select', key, keyPath)
        },

        toggleMobileMenu() {
            this.showMobileMenu = !this.showMobileMenu
        },

        closeMobileMenu() {
            this.showMobileMenu = false
        },

        handleMobileMenuClick(index) {
            this.activeIndex = index
            this.closeMobileMenu()

            // 根据选择的菜单项进行路由跳转
            const selectedItem = this.menuItems.find(item => item.index === index)
            if (selectedItem && selectedItem.path) {
                this.$router.push(selectedItem.path)
            }

            this.$emit('menu-select', index, [index])
        },

        checkMobile() {
            this.isMobile = window.innerWidth <= 768
            if (!this.isMobile && this.showMobileMenu) {
                this.closeMobileMenu()
            }
        },

        checkSmallMobile() {
            this.isSmallMobile = window.innerWidth <= 420
        },

        handleResize() {
            this.checkMobile()
            this.checkSmallMobile()
        }
    }
}
</script>

<style lang="scss" scoped>
.navigation-bar {
    .top-bar {
        background-color: #f5f7fa;
        padding: 8px 24px;
        border-bottom: 1px solid #e4e7ed;

        .top-content {
            display: flex;
            justify-content: space-between;
            align-items: center;
            max-width: 1175px;
            margin: 0 auto;

            .welcome-text {
                font-size: 12px;
                color: #606266;

                // 小屏幕下隐藏时间
                &.hide-time {
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }

            .auth-links {
                font-size: 12px;
                display: flex;
                align-items: center;

                .auth-link {
                    font-size: 12px;
                    margin: 0 4px;
                    font-weight: 400;
                }

                .separator {
                    color: #dcdfe6;
                    margin: 0 8px;
                }
            }
        }
    }

    .nav-bar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 24px;
        background-color: #fff;
        max-width: 1225px;

        margin: 0 auto;
        position: relative;
        z-index: 10;

        .nav-left {
            display: flex;
            align-items: center;
            white-space: nowrap;
            padding: 0 5px 0 0;

            .nav_icon {
                margin-right: 8px;
            }

            .nav_title {
                font-size: 18px;
                font-weight: 700;
                color: #1e3a8a;
            }
        }

        .nav-menu {
            border: none;
            height: 60px;
            width: 600px;
            min-width: 400px;
            display: flex;
            justify-content: space-between;

            .nav-menu-item {
                padding: 0;
                margin-top: 15px;
                height: 30px;
                line-height: 30px;
                font-size: 14px;
                color: #606266;

                &:hover {
                    color: rgb(37 99 235);
                }

                &.is-active {
                    color: rgb(37 99 235);
                    border-bottom: 2px solid rgb(37 99 235);
                    line-height: 25px;
                    font-weight: 600;
                }
            }
        }

        .nav-right {
            display: flex;
            align-items: center;
            gap: 15px;

            .desktop-search {
                width: 150px;
                min-width: 100px;

                .el-input {
                    width: 100%;
                    font-size: 14px;

                    ::v-deep .el-input__inner {
                        height: 30px;
                    }

                    ::v-deep .el-input__icon {
                        line-height: 30px;
                    }
                }
            }

            .mobile-menu-toggle {
                display: none;
                cursor: pointer;

                .hamburger-icon {
                    font-size: 24px;
                    color: #606266;

                    &:hover {
                        color: rgb(37 99 235);
                    }
                }
            }
        }
    }

    // 移动端菜单样式 - 简化版，没有菜单头
    .mobile-menu-container {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 99;

        .mobile-menu-overlay {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0);
        }

        .mobile-menu-content {
            position: absolute;
            top: 100px; // 从导航栏下面开始
            left: 0;
            width: 100%;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
            animation: slideDown 0.3s ease;
            background-color: rgba(255, 255, 255, 0.9);


            .mobile-menu-items {
                .mobile-menu-item {
                    padding: 16px 20px;
                    font-size: 16px;
                    color: #606266;
                    border-bottom: 1px solid #f5f7fa;
                    cursor: pointer;
                    transition: all 0.2s;
                    display: flex;
                    align-items: center;

                    &:hover {
                        background-color: #f5f7fa;
                        color: rgb(37 99 235);
                    }

                    &.active {
                        color: rgb(37 99 235);
                        background-color: #f0f7ff;
                        font-weight: 600;
                        position: relative;

                        &::before {
                            content: '';
                            position: absolute;
                            left: 0;
                            top: 0;
                            bottom: 0;
                            width: 4px;
                            background-color: rgb(37 99 235);
                        }
                    }

                    &:last-child {
                        border-bottom: none;
                    }

                    &::after {
                        content: '›';
                        margin-left: auto;
                        font-size: 18px;
                        color: #c0c4cc;
                    }

                    &:hover::after {
                        color: rgb(37 99 235);
                    }
                }
            }
        }
    }
}

// 动画 - 从上往下展开
@keyframes slideDown {
    from {
        transform: translateY(-20px);
        opacity: 0;
    }

    to {
        transform: translateY(0);
        opacity: 1;
    }
}

// 动画 - 从下往上收起
@keyframes slideUp {
    from {
        transform: translateY(0);
        opacity: 1;
    }

    to {
        transform: translateY(-20px);
        opacity: 0;
    }
}

// Vue过渡动画
.mobile-menu-enter-active {
    .mobile-menu-content {
        animation: slideDown 0.3s ease;
    }
}

.mobile-menu-leave-active {
    .mobile-menu-content {
        animation: slideUp 0.3s ease;
    }
}


// 媒体查询
@media (max-width: 768px) {
    .navigation-bar {
        .top-bar {
            padding: 8px 12px;

            .top-content {
                // width: 90vw;
                // max-width: 1180px;

                padding: 0 10px;

                .welcome-text {
                    font-size: 12px;
                    white-space: nowrap;
                }

                .auth-links {
                    .auth-link {
                        font-size: 12px;
                        margin: 0 2px;
                        white-space: nowrap;
                    }

                    .separator {
                        margin: 0 4px;
                    }
                }
            }
        }

        .nav-bar {
            // width: 90vw;
            // padding: 0 12px;
            height: 60px;

            .nav-left {
                .nav_title {
                    font-size: 20px;
                }
            }

            .desktop-menu {
                display: none !important;
            }

            .nav-right {
                .desktop-search {
                    display: none !important;
                }

                .mobile-menu-toggle {
                    display: block !important;
                }
            }
        }

        .mobile-menu-container {
            .mobile-menu-content {
                width: 100vw;
                top: 98px; // 根据导航栏高度调整
            }
        }
    }
}

@media (max-width: 480px) {
    .navigation-bar {
        .top-bar {
            padding: 6px 8px;
            min-width: 406px;

            .top-content {
                width: 95vw;
                padding: 0 5px;
                margin: 0;

                .welcome-text {
                    font-size: 12px;
                }

                .auth-links {
                    .auth-link {
                        font-size: 12px;
                    }

                    .separator {
                        margin: 0 2px;
                    }
                }
            }
        }

        .nav-bar {
            width: 95vw;
            padding: 0 8px;
            height: 56px;

            .nav-left {
                .nav_title {
                    font-size: 18px;
                }
            }
        }

        .mobile-menu-container {
            .mobile-menu-content {
                top: 89px; // 根据导航栏高度调整
                width: 100vw;

                .mobile-menu-items {
                    .mobile-menu-item {
                        padding: 10px 16px;
                        font-size: 13px;
                    }
                }
            }
        }
    }
}

// 新增：小屏幕媒体查询（宽度<420px）
@media (max-width: 420px) {
    .navigation-bar {
        .top-bar {
            .top-content {
                .welcome-text {
                    // 在小屏幕下，只显示文本，不显示时间
                    max-width: 180px; // 给文本设置最大宽度
                }
            }
        }
    }
}

@media (max-width: 350px) {
    .navigation-bar {
        .top-bar {
            .top-content {
                .welcome-text {
                    font-size: 10px;
                    max-width: 150px; // 更小屏幕下进一步限制宽度
                }

                .auth-links {
                    .auth-link {
                        font-size: 10px;
                    }

                    .separator {
                        font-size: 10px;
                    }
                }
            }
        }

        .nav-bar {
            height: 52px;

            .nav-left {
                .nav_title {
                    font-size: 14px;
                }
            }
        }

        .mobile-menu-container {
            .mobile-menu-content {
                top: 82px; // 根据导航栏高度调整

                .mobile-menu-items {
                    .mobile-menu-item {
                        padding: 12px 14px;
                        font-size: 14px;
                    }
                }
            }
        }
    }
}
</style>